/* app/js/src/components/common/wizard/wizard-step.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  margin-bottom: 30px;
  display: none;
}
:host.active {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  flex-direction: column;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
}
h2 {
  font-size: 12px;
  font-weight: normal;
  letter-spacing: 0.1px;
  margin: 0 0 5px 0;
  color: #7d8fa1;
}
/*# sourceMappingURL=wizard-step.component.css.map */
